import React from 'react';
import type { MomentInput } from 'moment';
import Loading from '@intelligence/components/Loading';
import { useEventsTimeline } from '../../utils/eventsTimeline';
import './index.scss';

interface IProps {
  eventsData?: any;
  loading?: boolean;
  selectedDate?: [MomentInput, MomentInput];
}

const CLS = 'dbs-live-events-card';

const EventsTimelineCard: React.FC<IProps> = ({
  eventsData,
  loading = false,
  selectedDate,
}) => {
  const { scrollRef, setRowRef, eventRows, isHighlighted } = useEventsTimeline({
    eventsData,
    selectedMonth: selectedDate?.[1],
  });

  let body: React.ReactNode;
  if (loading) {
    body = <Loading style={{ minHeight: '182px' }} />;
  } else if (eventRows.length === 0) {
    body = <div className={`${CLS}__empty`}>No Data</div>;
  } else {
    body = (
      <div className={`${CLS}__scroll`} ref={scrollRef}>
        <div className={`${CLS}__track`}>
          {eventRows.map(row => {
            const highlighted = isHighlighted(row.date);
            return (
              <div
                key={row.id}
                ref={setRowRef(row.id)}
                className={`${CLS}__row ${highlighted ? `${CLS}__row--active` : ''}`}
              >
                <div className={`${CLS}__date-wrap`}>
                  <div
                    className={`${CLS}__date ${highlighted ? `${CLS}__date--active` : ''}`}
                  >
                    {row.date}
                  </div>
                </div>
                <div
                  className={`${CLS}__event-main ${highlighted ? `${CLS}__event-main--active` : ''}`}
                >
                  <span className={`${CLS}__event-content`}>{row.event_content}</span>
                  {row.hasImportance && (
                    <span className={`${CLS}__event-tag ${CLS}__event-tag--high`}>High</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className={CLS}>
      <div className={`${CLS}__header`}>
        <span className={`${CLS}__title`}>Events</span>
      </div>
      <div className={`${CLS}__body`}>{body}</div>
    </div>
  );
};

export default EventsTimelineCard;
